import React, { Component } from "react";
import { connect } from "react-redux";
import { Menu } from "antd";
import { Link } from "react-router-dom";

import SidebarLogo from "./SidebarLogo";

import Auxiliary from "util/Auxiliary";
//import UserProfile from "./UserProfile";
//import AppsNavigation from "./AppsNavigation";

import {
  ActionOrganisationsList,
} from "appRedux/actions/Organisations"
import {
  ActionUsersGet,
} from "appRedux/actions/System/Users"
import {
  ResetDashboardClient,
} from "appRedux/actions/Dashboard"
import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE
} from "constants/ThemeSetting";
import IntlMessages from "util/IntlMessages";

import ShowForPermission from "util/ShowForPermission";

const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;

class SidebarContent extends Component {

  getNoHeaderClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR || navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) {
      return "gx-no-header-notifications";
    }
    return "";
  };
  getNavStyleSubMenuClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
      return "gx-no-header-submenu-popup";
    }
    return "";
  };

  
  componentDidUpdate(prevProps) {
    const { ActionUsersGet, userid, ActionOrganisationsList } = this.props
    
    if (this.props.userid !== prevProps.userid || prevProps.userid === null) {
      // Get current user
      if (userid) {
        ActionUsersGet(userid)
      }

      // Get all organisations
      ActionOrganisationsList()
    }
  }


  handleClickClient = () => {
    const { ResetDashboardClient } = this.props
    ResetDashboardClient()
  }

  can = (permission) => {
    const { permissions } = this.props
    return permissions.includes(permission)
  }

  render() {
    const { themeType, navStyle, pathname, db_curr_user, db_organisations } = this.props;
    const path = pathname.substr(1);
    const defaultOpenKeys = path.split('/');

    return (<Auxiliary>

      <SidebarLogo />
      <div className="gx-sidebar-content">
        {/**
            <div className={`gx-sidebar-notifications ${this.getNoHeaderClass(navStyle)}`}>
              <UserProfile/>
              <AppsNavigation/>
            </div>
          */}

        <div className="gx-layout-sider-scrollbar" style={{overflow:"auto",paddingTop:"32px"}}>
          <Menu
            defaultOpenKeys={defaultOpenKeys}
            selectedKeys={defaultOpenKeys}
            theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
            mode="inline">
            
            <Menu.Item key="dashboard">	
              <Link to="/dashboard"><i className="icon icon-widgets" />	
                <IntlMessages id="sidebar.dashboard" /></Link>	

            </Menu.Item>


            {
              // (this.can('read-clients') || this.can('view-clients-name-contact') || this.can('read-clients-detail-own')) &&
              (this.can('manage-my-clients') || this.can('view-all-clients-de-identified')) &&
              <Menu.Item key="clients">
             
                <Link to="/clients" onClick={this.handleClickClient}><i className="icon icon-anchor" />
                  <IntlMessages id="sidebar.page.clients" /></Link>
             
            </Menu.Item>}

            {
              (this.can('view-my-organisations') || this.can('manage-my-organisations')) &&
              <SubMenu key="manage-my-organisations" className={this.getNavStyleSubMenuClass(navStyle)}
                title={<span> <i className="icon icon-auth-screen" />
                  <IntlMessages id="sidebar.user.management-my-organisations" /></span>}
              >
                {db_curr_user ? db_organisations.filter(item => db_curr_user.organisations.includes(item.id)).map(item => {

                  return (

                    <Menu.Item key={item.id}>
                      <ShowForPermission permission="manage-my-organisations">
                        <Link to={"/manage-my-organisations/" + item.id}>
                          <div id={item.id}>{item.name}</div></Link>
                      </ShowForPermission>
                    </Menu.Item>
                  )

                }) : null
                }

              </SubMenu>}
            <Menu.Item key="assessments">
              <ShowForPermission permission="read-survey">
                <Link to="/assessments"><i className="icon icon-badge" />
                  <IntlMessages id="sidebar.page.assessments" /></Link>
              </ShowForPermission>
            </Menu.Item>


            {this.can('manage-system') &&
              <MenuItemGroup key="user-management-item-group" className="gx-menu-group"
                title={<IntlMessages id="sidebar.group.system" />} defaultSelectedKeys="roles">
                <SubMenu key="user-management" className={this.getNavStyleSubMenuClass(navStyle)}
                  title={<span> <i className="icon icon-auth-screen" />
                    <IntlMessages id="sidebar.user.management" /></span>}
                >

                  <Menu.Item key="roles">
                    <ShowForPermission permission="read-roles">
                      <Link to="/user-management/roles">
                        <IntlMessages id="sidebar.page.roles" /></Link>
                    </ShowForPermission>
                  </Menu.Item>

                  <Menu.Item key="users">
                    <ShowForPermission permission="read-users">
                      <Link to="/user-management/users">
                        <IntlMessages id="sidebar.page.users" /></Link>
                    </ShowForPermission>
                  </Menu.Item>

                  <Menu.Item key="trial_users">
                    <ShowForPermission permission="manage-trial-user-requests">
                      <Link to="/user-management/trial-users">
                        <IntlMessages id="sidebar.page.trial-users" /></Link>
                    </ShowForPermission>
                  </Menu.Item>

                </SubMenu>

                <Menu.Item key="sync">
                  <ShowForPermission permission="sync-limesurvey">
                    <Link to="/sync"><i className="icon icon-map-clustering" />
                      <IntlMessages id="sidebar.page.sync" /></Link>
                  </ShowForPermission>
                </Menu.Item>
                <Menu.Item key="organisations">
                  <ShowForPermission permission="manage-organisations">
                    <Link to="/organisations"><i className="icon icon-anchor" />
                      <IntlMessages id="sidebar.page.organisations" /></Link>
                  </ShowForPermission>
                </Menu.Item>

                <Menu.Item key="bannerblocks">
                  <ShowForPermission permission="manage-bannerblocks">
                    <Link to="/bannerblocks"><i className="icon icon-anchor" />
                      <IntlMessages id="sidebar.page.bannerblocks" /></Link>
                  </ShowForPermission>
                </Menu.Item>

                <Menu.Item key="deploy">
                  <ShowForPermission permission="manage-deploy">
                    <Link to="/deploy"><i className="icon icon-anchor" />
                      <IntlMessages id="sidebar.page.deploy" /></Link>
                  </ShowForPermission>
                </Menu.Item>
                
              </MenuItemGroup>
            }
          </Menu>
        </div>
      </div>
    </Auxiliary>
    );
  }
}

SidebarContent.propTypes = {};

const mapStateToProps = ({ settings, auth, system }) => {
  const { navStyle, themeType, locale, pathname } = settings;
  const { permissions, userid } = auth;

  const { organisations, users } = system;
  const { db_organisations } = organisations;
  const { db_curr_user } = users;

  return { navStyle, themeType, locale, pathname, permissions, db_organisations, userid, db_curr_user }
};



export default connect(mapStateToProps, {
  ActionOrganisationsList,
  ActionUsersGet,
  ResetDashboardClient,
})(SidebarContent);